/* unplugin-vue-components disabled */import script from "./header-personspace.vue?vue&type=script&setup=true&lang=js"
export * from "./header-personspace.vue?vue&type=script&setup=true&lang=js"

import "./header-personspace.vue?vue&type=style&index=0&id=fbf8dd22&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbf8dd22"]])

export default __exports__